module.exports = __webpack_public_path__ + "img/nabl_gallery0.e9c13db2.jpg";